import { v4 as uuid } from 'uuid';
import { PricingResponseDTOBuilder } from '../';
import type { PricingDTOTypes, DeliveryDTOTypes } from '../types';

export class DeliveryRecipeResponseDTOBuilder {
  #name = 'Recipe name';
  #imageURL = 'https://recipe-url.com';

  public withImageURL(url: string) {
    this.#imageURL = url;
    return this;
  }

  public withName(name: string) {
    this.#name = name;
    return this;
  }

  public build() {
    return {
      id: uuid(),
      name: this.#name,
      imageUrl: this.#imageURL,
    };
  }
}

export class DeliveryResponseDTOBuilder {
  #pricing = new PricingResponseDTOBuilder().build();
  #recipes: DeliveryDTOTypes.DeliveryDTO['recipes'] = [
    {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      name: 'string',
      imageUrl: 'string',
    },
  ];
  #displayStatus: DeliveryDTOTypes.DeliveryDTO['displayStatus'] = 'DELIVERED';
  #isSkippable = false;
  #numberOfPortions = 2;
  #isBoxSizeEditable = false;
  #isDeliveryDayEditable = false;
  #isAddressEditable = false;
  #address: DeliveryDTOTypes.DeliveryDTO['address'] = {
    line1: '123 Fake St',
    line2: 'Apt 1',
    city: 'Dublin',
    province: 'Leinster',
    country: 'Ireland',
    postalCode: 'D01 1234',
    formattedAddress: '123 Fake St, Apt 1, Dublin, Leinster, D01 1234, Ireland',
    formattedShortAddress: '123 Fake St, Apt 1, Dublin, D01 1234',
  };

  public withPricing(pricing: PricingDTOTypes.GetPredictPricing200DTO): DeliveryResponseDTOBuilder {
    this.#pricing = pricing;
    return this;
  }

  public withNoRecipes(): this {
    this.#recipes = [];
    return this;
  }

  public withRecipe(recipe: DeliveryDTOTypes.DeliveryDTO['recipes'][number]): this {
    this.#recipes.push(recipe);
    return this;
  }

  public withRecipes(recipes: DeliveryDTOTypes.DeliveryDTO['recipes']) {
    this.#recipes = recipes;
    return this;
  }

  public withDisplayStatus(
    displayStatus: DeliveryDTOTypes.DeliveryDTO['displayStatus'],
  ): DeliveryResponseDTOBuilder {
    this.#displayStatus = displayStatus;
    return this;
  }

  public withIsSkippable(isSkippable: boolean) {
    this.#isSkippable = isSkippable;
    return this;
  }

  public withBoxSizeEditable(isBoxSizeEditable = true) {
    this.#isBoxSizeEditable = isBoxSizeEditable;
    return this;
  }

  public withDeliveryDayEditable(isDeliveryDayEditable = true) {
    this.#isDeliveryDayEditable = isDeliveryDayEditable;
    return this;
  }

  public withAddressEditable(isAddressEditable = true) {
    this.#isAddressEditable = isAddressEditable;
    return this;
  }

  public withNumberOfPortions(numberOfPortions: number) {
    this.#numberOfPortions = numberOfPortions;
    return this;
  }

  public withAddress(address: DeliveryDTOTypes.DeliveryDTO['address']) {
    this.#address = address;
    return this;
  }

  public build(): DeliveryDTOTypes.DeliveryDTO {
    return {
      deliveryDate: '2025-01-01',
      humanReadableDeliveryDate: 'string',
      displayStatus: this.#displayStatus,
      isEditable: true,
      isSkippable: this.#isSkippable,
      pricing: this.#pricing,
      menuOpenTime: 'string',
      deliveryTimeRange: '8am - 7pm',
      menuId: 0,
      editRecipesUntilTime: 'string',
      humanReadableCutoffDate: 'string',
      numberOfPortions: this.#numberOfPortions,
      isBoxSizeEditable: this.#isBoxSizeEditable,
      isDeliveryDayEditable: this.#isDeliveryDayEditable,
      isAddressEditable: this.#isAddressEditable,
      recipes: this.#recipes,
      address: this.#address,
    };
  }
}

export class MyDeliveriesResponseDTOBuilder {
  public build(): DeliveryDTOTypes.MyDeliveriesDTO {
    return {
      status: 'ok',
      data: {
        upcoming: [new DeliveryResponseDTOBuilder().build()],
        last: new DeliveryResponseDTOBuilder().build(),
      },
    };
  }
}
